import { render, staticRenderFns } from "./BoxIcon.vue?vue&type=template&id=cdc2c034&"
import script from "./BoxIcon.vue?vue&type=script&lang=js&"
export * from "./BoxIcon.vue?vue&type=script&lang=js&"
import style0 from "./BoxIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports